import type {Editor} from 'grapesjs';
import type {MediaControlsItemProps} from '@Components/contextual-menu/components/media-controls-item';
import {getCropAspectPresetItems} from '@Components/poster-editor/components/crop-aspect-presets/crop-aspect-presets.library';
import type {EmailImageCropModeState} from '@EmailMakerReact/lib/email-maker-image-crop-library';
import {resetImageCropToOriginal, setImageCropAspectRatio} from '@EmailMakerReact/lib/email-maker-image-crop-library';

export function getEmailImageCropPresetItems(editor: Editor, cropState: EmailImageCropModeState): MediaControlsItemProps[] {
  return getCropAspectPresetItems({
    activeAspectRatio: cropState.aspectRatio,
    isOriginalSelected: cropState.isOriginalAspectRatio,
    originalAspectRatio: getImageAspectRatio(cropState),
    onSelect: (ratio: number | null): void => {
      setImageCropAspectRatio(editor, ratio);
    },
    onSelectOriginal: (): void => {
      resetImageCropToOriginal(editor);
    },
  });
}

function getImageAspectRatio({imageSize}: EmailImageCropModeState): number | null {
  if (imageSize.width <= 0 || imageSize.height <= 0) {
    return null;
  }
  return imageSize.width / imageSize.height;
}
